import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectIsCms } from "../../../redux/slices/configSlice";
import { selectAllRegistration } from "../../../redux/slices/registrationSlice";
import {
    selectCmsControlByIdByPage,
    selectCmsOptionByType,
} from "../../../redux/slices/cmsSettingsSlice";
import Submit from "./Submit";

const ConnectedSubmit = ({ controlId }) => {
    const {
        ENUMS: { DefaultView, CMS_Control },
    } = constants;
    const isCms = useSelector(selectIsCms);
    const { storeCart = [], allowEarlyFormSubmissionStorePage = false } =
        useSelector(selectAllRegistration);
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_P2P_STORE,
            state,
        ),
    );
    const {
        options: { nextButtonLabel = "Next", skipButtonLabel = "Skip" },
    } = control;

    const advanceForwardButtonLabel =
        storeCart.length > 0 ? nextButtonLabel : skipButtonLabel;
    const earlySubmissionLabel = useSelector((state) =>
        selectCmsOptionByType(
            CMS_Control.P2P_FOOTER_REGISTRATION_BUTTONS,
            "ifNoTotalCompleteButtonLabel",
            state,
        ),
    );

    const submitProps = {
        advanceForwardButtonLabel:
            allowEarlyFormSubmissionStorePage && earlySubmissionLabel
                ? earlySubmissionLabel
                : advanceForwardButtonLabel,
        controlId,
        isCms,
    };
    return <Submit {...submitProps} />;
};

ConnectedSubmit.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedSubmit;
